import { getEnvironmentValues } from "@/config/environment";

export const isDevelopment = () => getEnvironmentValues().isDev;
export const isProduction = () => getEnvironmentValues().isProd;
export const environmentMode = () => getEnvironmentValues().mode;

export const debugE2E = () => getEnvironmentValues().debugE2E === "true";
export const showDevTools = () => getEnvironmentValues().devTools === "true";
export const showQueryDevTools = () =>
  showDevTools() && getEnvironmentValues().queryDevTools === "true";
export const showStateDevTools = () =>
  showDevTools() && getEnvironmentValues().stateDevTools === "true";

export const getPowerBiConfigs = () => getEnvironmentValues().powerBiConfigs;

export const hasPowerBiConfigs = () => {
  const { ctid, defaultReportID } = getPowerBiConfigs();
  const hasCTID = !!ctid?.trim();
  const hasDefaultReportID = !!defaultReportID?.trim();

  return hasCTID && hasDefaultReportID;
};

export const getPusherConfigs = () => getEnvironmentValues().pusherConfigs;

export const isDebugModeActivated = () =>
  getEnvironmentValues().debugMode === "true";

export const getBackendUrl = () => {
  const { apiUrl } = getEnvironmentValues();
  return apiUrl.substring(0, apiUrl.lastIndexOf("/"));
};

export const getBroadcastingAuthEndpoint = () => {
  const { apiUrl } = getEnvironmentValues();
  return `${apiUrl}/broadcasting/auth`;
};

export const getMapTilesConfigs = () => getEnvironmentValues().mapTilesConfigs;

export const areTilesEnabledAndValids = (tilesInfo) => {
  if (!tilesInfo) {
    return false;
  }

  const {
    tilesUrl,
    tilesSize,
    tilesMaxZoom,
    tilesMinZoom,
    tilesBottomLeftCoordinates,
    tilesTopRightCoordinates,
  } = tilesInfo;

  return (
    tilesUrl &&
    tilesSize &&
    tilesMaxZoom &&
    tilesMinZoom &&
    tilesBottomLeftCoordinates &&
    tilesTopRightCoordinates
  );
};

export const getInstanceName = () => {
  const { apiUrl } = getEnvironmentValues();
  const hostname = new URL(apiUrl).host;

  const includesUrl = hostname.includes(".stelar.ai")
    ? ".stelar.ai"
    : ".beap.ai";

  const instanceName = hostname.includes(includesUrl)
    ? hostname.substring(0, hostname.lastIndexOf(includesUrl))
    : hostname;

  return instanceName;
};

export const getGAMeasurmentId = () => {
  const { googleAnalytics } = getEnvironmentValues();
  return googleAnalytics.measurementId;
};
